import UserInitialsImageUploader from './UserInitialsInputFile.component';

export default UserInitialsImageUploader;
